function simulateClick(e) {
  if (e.key === "Enter" || e.key === " ") {
    e.target.click();
  }
}

export default simulateClick;
